import { ReactEditor, useFocused, useSelected, useSlateStatic } from 'slate-react';
import { Button } from 'antd';

const Image = ({ attributes, children, element }) => {
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);
  const selected = useSelected();
  const focused = useFocused();

  return (
    <div {...attributes}>
      {children}
      <div contentEditable={false} className="relative">
        <img
          src={element.url}
          className={`w-full block max-w-[100%] object-cover ${selected && focused ? 'border-2 border-[#B4D5FF]' : ''}`}
        />
        <Button
          active
          onClick={() => Transforms.removeNodes(editor, { at: path })}
          className={`absolute top-0 left-0 bg-white opacity-80 rounded-md p-1 m-1 ${
            selected && focused ? '' : 'hidden'
          }`}>
          <Button>delete</Button>
        </Button>
      </div>
    </div>
  );
};

export const Element = props => {
  const { attributes, children, element } = props;
  switch (element.type) {
    case 'image':
      return <Image {...props} />;
    default:
      return <p {...attributes}>{children}</p>;
  }
};
